import { GscIcon } from "./types";

const googleMaterialIcon: Pick<GscIcon, "viewBox" | "height" | "width"> = {
  viewBox: "0 -960 960 960",
  width: 24,
  height: 24,
};

const gscIconSet: Record<string, GscIcon> = {
  "chevron-right": {
    path: "M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z",
    ...googleMaterialIcon,
  },
  wallpaper: {
    path: "M200-120q-33 0-56.5-23.5T120-200v-240h80v240h240v80H200Zm320 0v-80h240v-240h80v240q0 33-23.5 56.5T760-120H520ZM240-280l120-160 90 120 120-160 150 200H240ZM120-520v-240q0-33 23.5-56.5T200-840h240v80H200v240h-80Zm640 0v-240H520v-80h240q33 0 56.5 23.5T840-760v240h-80Zm-140-40q-26 0-43-17t-17-43q0-26 17-43t43-17q26 0 43 17t17 43q0 26-17 43t-43 17Z",
    ...googleMaterialIcon,
  },
  close: {
    path: "m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z",
    ...googleMaterialIcon,
  },
  "open-external": {
    path: "M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h560v-280h80v280q0 33-23.5 56.5T760-120H200Zm188-212-56-56 372-372H560v-80h280v280h-80v-144L388-332Z",
    ...googleMaterialIcon,
  },
};

export default gscIconSet;
